/**
 * ツアー詳細画面用JavaScript
 */
$(document).ready(function () {
    // お気に入りリスト生成
    genarateFavoriteList();
    // 閲覧履歴リスト生成
    genarateHistoryList();
});

/**
 * お気に入りリスト生成
 */
function genarateFavoriteList() {
    // データ取得
    const tcd = $('#favdata').attr('tcd');
    const orgFavData = localStorage.getItem('stw_fav');
    let favorites = new Array();
    let existsInq = false;
    if (orgFavData) {
        favorites = JSON.parse(orgFavData);
        for (favorite of favorites) {
            favorite.isInq = false;
            if (favorite.inq == 1) {
                existsInq = true;
                favorite.isInq = true;
            }
        }
    }
    const favData = {
        favorites: favorites,
        existsInq: existsInq
    };
    // console.log(JSON.stringify(favData));

    // HTML生成（Handlebars）
    const source = $('#favorite_template').html();
    const template = Handlebars.compile(source);
    const html = template(favData);
    $('#favorite_list').html(html);

    //--- イベント登録 ----
    // 削除ボタン
    $('.delete-favorite').onclick = "";
    $('.delete-favorite').click(deleteFavorite);
    // 一括見積もりボタン
    $('#favorite_estimate').onclick = "";
    $('#favorite_estimate').click(estimateFavorite);

    return false;
}

/**
 * お気に入り削除
 */
function deleteFavorite() {
    const tourCode = $(this).parent().attr('tour_code');
    const orgFavData = localStorage.getItem('stw_fav');
    if (orgFavData) {
        favorites = JSON.parse(orgFavData);
        let deleteIndex = -1;
        for (let index = 0; index < favorites.length; index++) {
            let favorite = favorites[index];
            if (favorite.tcd === tourCode) {
                deleteIndex = index;
                break;
            }
        }
        if (deleteIndex >= 0) {
            favorites.splice(deleteIndex, 1);
            localStorage.setItem('stw_fav', JSON.stringify(favorites));
            // お気に入りリスト再作成
            genarateFavoriteList();
            // お気に入りボタン再設定（/assets/js/pages/tour/deteil.js）
            setFavoriteButton();
        }
    }
    return false;
}


/**
 * 一括見積もり
 */
function estimateFavorite() {
    const tourCodes = [];
    $('.favorite_check:checked').each(function(index, elem) {
        const tourCode = $(elem).parent().parent().attr('tour_code');
        tourCodes.push(tourCode);
    });
    if (tourCodes.length==0) {
        alert('ツアーを選択してください。');
        return false;
    }

    // スマホ判定
    let deviceType = 'pc';
    let angle = screen && screen.orientation && screen.orientation.angle;
    if (angle === undefined) {
        angle = window.orientation;    // iOS用
    }
    if (window.outerWidth <= 700 || (angle != 0 && window.outerWidth <= 926)) {
        deviceType = 'sp';
    }

    // マイページへ遷移
    let url = $('#mypage_url').val();
    url += '/form/inquiry.html?tourcodes=' + tourCodes.join(',') + '&year=&device=' + deviceType;
    // console.log(url);
    location.href = url;
    return false;
}

/**
 * 閲覧履歴生成
 */
function genarateHistoryList() {
    // データ取得
    const tcd = $('#favdata').attr('tcd');
    const orgHistory = $.cookie('stw_history');
    let histories = [];
    if (orgHistory) {
        histories = JSON.parse(orgHistory);
    }

    // HTML生成（Handlebars）
    const source = $('#history_template').html();
    const template = Handlebars.compile(source);
    const html = template(histories);
    $('#history_list').html(html);

    return false;
}
